import {SolePropTransactionVolume, SolePropTransactionVolumeMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableSolePropTransactionVolumeProps {
	transactionVolume?: SolePropTransactionVolume
	setTransactionVolume: (value: SolePropTransactionVolume) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: SolePropTransactionVolume) => void
	className?: string
}

export function EditableSolePropTransactionVolumeField(props: EditableSolePropTransactionVolumeProps) {
	if (props.transactionVolume) {
		return (
			<Editable
				label="Transaction Volume"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setTransactionVolume}
				value={props.transactionVolume}
				initial={props.transactionVolume}
				update={props.update}
				className={props.className}
				possibleValues={SolePropTransactionVolumeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
